module.exports = __webpack_public_path__ + "static/media/UNA.21907525.svg";